import {getLoginUser, logOutUser} from '@/api/login'
import {getToken, removeToken, setToken} from '@/utils/auth'

const user = {
    state: {
        token: getToken(), user: ''
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_USER: (state, user) => {
            state.user = user
        },
    },

    actions: {
        // 登录
        // Login({commit}, userInfo) {
        //     return new Promise((resolve, reject) => {
        //         loginUser(userInfo).then(res => {
        //             setToken(res.msg)
        //             commit('SET_TOKEN', res.msg)
        //             resolve()
        //         }).catch(error => {
        //             reject(error)
        //         })
        //     })
        // },
        Login({commit}, token) {
            return new Promise((resolve, reject) => {
                setToken(token)
                commit('SET_TOKEN', token)
                resolve()
            })
        },

        // 获取用户信息
        GetInfo({commit}) {
            return new Promise((resolve, reject) => {
                getLoginUser().then(res => {
                    const user = res.data
                    commit('SET_USER', user)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 退出系统
        LogOut({commit}) {
            return new Promise((resolve, reject) => {
                logOutUser().then(res => {
                    commit('SET_TOKEN', '')
                    commit('SET_USER', undefined)
                    removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

    }
}

export default user
